import { formatDistanceToNow } from 'date-fns';
import { getDateFnsLocale } from '@/locales/date-fns-locales-translation';

export function formatTimeAgo(date?: Date | null | undefined, language?: string): string | null {
  if (!date || !language) return null;

  return formatDistanceToNow(date, {
    addSuffix: true,
    locale: getDateFnsLocale(language),
  });
}
